import * as React from 'react';
import { useSelector } from 'react-redux';
import { SeoMarkedList } from '../../components/SeoMarkedList';
import { selectMarkedListItems } from '../../selectors/seo';

export const SeoMarkedListContainer: React.FC = () => {
  const items = useSelector(selectMarkedListItems);

  if (!items.length) {
    return null;
  }

  return <SeoMarkedList items={items} />;
};
